import { useState } from 'react';

const useModal = () => {
    //Estado de controle de visibilidade do modal
    const [visibleModal, setVisibleModal] = useState(false);

    //Função de mudança de estado do modal
    const toggleModal = (setSelection = () => { }, reset = () => { }) => {
        reset();
        if (!visibleModal) {
            setSelection();
        }
        setVisibleModal(!visibleModal);
    };
    return [visibleModal, toggleModal];
}

export default useModal;